import { createSelector } from 'reselect';

export const UserData = (state) => state.userData;

export const getUserData = createSelector(UserData, (data) => {
  return data?.isImpersonation ? data?.impersonationData : data?.userData ?? {};
});

export const getIsImpersonation = createSelector(UserData, (data) => {
  return data?.isImpersonation ?? false;
});
